import { formatDateHuman } from "../date-utils";
import { formatValueHuman } from "../format-utils";
export const progettoDtoFields = [{
        name: "codiceCommessa",
        title: "Codice commessa",
        render: (record) => record.oid
    }, {
        name: "stato",
        title: "Stato",
        render: (record) => record.stato == null || record.stato == "" ? "" : `<span class="tag ${record.stato == 'Chiuso' ? 'is-success' : 'is-info'}">${record.stato}</span>`
        // }, {
        //   name: "progettoSizeDescription",
        //   title: "Dimensione"
        // }, {
        //   name: "industryDescription",
        //   title: "Industria"
        // }, {
        //   name: "sourceDescription",
        //   title: "Sorgente"
    }, {
        name: "gestioneSeparata",
        title: "Gestione Separata",
        render: (record) => formatValueHuman(record.gestioneSeparata)
    }, {
        name: "codiceProgetto",
        title: "Codice Progetto",
        render: (record) => formatValueHuman(record.codiceProgetto)
    }, {
        name: "titolo",
        title: "Titolo",
        render: (record) => `<span style="max-width:20em;max-height: 2.3em;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">${record.titoloProgetto}</span>`
        // }, {
        //   name: "countryDescription",
        //   title: "Nazione"
    }, {
        name: "codiceCUP",
        title: "Codice CUP",
        render: (record) => formatValueHuman(record.codiceCUP)
    }, {
        name: "ufficioRiferimento",
        title: "Ufficio Riferimento",
        render: (record) => formatValueHuman(record.ufficioRiferimento)
    }, {
        name: "cliente",
        title: "Cliente",
        render: (record) => record.cliente
    }, {
        name: "avviso",
        title: "Avviso",
        render: (record) => formatValueHuman(record.avviso)
    }, {
        name: "tipologia",
        title: "Tipologia",
        render: (record) => formatValueHuman(record.tipologia)
    }, {
        name: "delibera",
        title: "Delibera",
        render: (record) => formatValueHuman(record.delibera)
    }, {
        name: "utenza",
        title: "Utenza",
        render: (record) => formatValueHuman(record.utenza)
    }, {
        name: "contributoRichiesto",
        title: "Contributo richiesto",
        render: (record) => formatValueHuman(record.contributoRichiesto)
    }, {
        name: "decretoApprovazione",
        title: "Decreto Approvazione",
        render: (record) => formatValueHuman(record.decretoApprovazione)
    }, {
        name: "risorsaResponsabile",
        title: "Risorsa Responsabile",
        render: (record) => formatValueHuman(record.risorsaResponsabile)
    }, {
        name: "gestioneErogazione",
        title: "Gestione/Erogazione",
        render: (record) => formatValueHuman(record.gestioneErogazione)
    }, {
        name: "monitoraggioRendicontazione",
        title: "Monitoraggio/Rendicontazione",
        render: (record) => formatValueHuman(record.monitoraggioRendicontazione)
    }, {
        name: "dataPartenzaPrevista",
        title: "Data Partenza prevista",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.dataPartenzaPrevista)
    }, {
        name: "dataInizio",
        title: "Data Inizio",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.dataInizioProgetto)
    }, {
        name: "dataFine",
        title: "Data Fine",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.dataFineProgetto)
    }, {
        name: "dataRendicontazione",
        title: "Data Rendicontazione",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.dataRendicontazione)
    }, {
        name: "dataUltimoAggiornamento",
        title: "Data Ult. agg.",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.dataUltimoAggiornamento)
    }];
